"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFileReaderSource = void 0;

var basesource_js_1 = require("./basesource.js");

var FileReaderSource = /*#__PURE__*/function (_basesource_js_1$Base) {
  (0, _inherits2.default)(FileReaderSource, _basesource_js_1$Base);

  var _super = _createSuper(FileReaderSource);

  function FileReaderSource(file) {
    var _this;

    (0, _classCallCheck2.default)(this, FileReaderSource);
    _this = _super.call(this);
    _this.file = file;
    return _this;
  }

  (0, _createClass2.default)(FileReaderSource, [{
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(slice, signal) {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var blob = _this2.file.slice(slice.offset, slice.offset + slice.length);

                  var reader = new FileReader();

                  reader.onload = function (event) {
                    return resolve(event.target.result);
                  };

                  reader.onerror = reject;
                  reader.onabort = reject;
                  reader.readAsArrayBuffer(blob);

                  if (signal) {
                    signal.addEventListener('abort', function () {
                      return reader.abort();
                    });
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchSlice(_x, _x2) {
        return _fetchSlice.apply(this, arguments);
      }

      return fetchSlice;
    }()
  }]);
  return FileReaderSource;
}(basesource_js_1.BaseSource);
/**
 * Create a new source from a given file/blob.
 * @param {Blob} file The file or blob to read from.
 * @returns The constructed source
 */


function makeFileReaderSource(file) {
  return new FileReaderSource(file);
}

exports.makeFileReaderSource = makeFileReaderSource;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0lBRU1BLGdCOzs7OztFQUNKLDBCQUFZQyxJQUFaLEVBQWdCO0lBQUE7O0lBQUE7SUFDZDtJQUNBLE1BQUtBLElBQUwsR0FBWUEsSUFBWjtJQUZjO0VBR2Y7Ozs7O2dHQUVELGlCQUFpQkMsS0FBakIsRUFBd0JDLE1BQXhCO1FBQUE7O1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUEsaUNBQ1MsSUFBSUMsT0FBSixDQUFZLFVBQUNDLE9BQUQsRUFBVUMsTUFBVixFQUFvQjtrQkFDckMsSUFBTUMsSUFBSSxHQUFHLE1BQUksQ0FBQ04sSUFBTCxDQUFVQyxLQUFWLENBQWdCQSxLQUFLLENBQUNNLE1BQXRCLEVBQThCTixLQUFLLENBQUNNLE1BQU4sR0FBZU4sS0FBSyxDQUFDTyxNQUFuRCxDQUFiOztrQkFDQSxJQUFNQyxNQUFNLEdBQUcsSUFBSUMsVUFBSixFQUFmOztrQkFDQUQsTUFBTSxDQUFDRSxNQUFQLEdBQWdCLFVBQUNDLEtBQUQ7b0JBQUEsT0FBV1IsT0FBTyxDQUFDUSxLQUFLLENBQUNDLE1BQU4sQ0FBYUMsTUFBZCxDQUFsQjtrQkFBQSxDQUFoQjs7a0JBQ0FMLE1BQU0sQ0FBQ00sT0FBUCxHQUFpQlYsTUFBakI7a0JBQ0FJLE1BQU0sQ0FBQ08sT0FBUCxHQUFpQlgsTUFBakI7a0JBQ0FJLE1BQU0sQ0FBQ1EsaUJBQVAsQ0FBeUJYLElBQXpCOztrQkFFQSxJQUFJSixNQUFKLEVBQVk7b0JBQ1ZBLE1BQU0sQ0FBQ2dCLGdCQUFQLENBQXdCLE9BQXhCLEVBQWlDO3NCQUFBLE9BQU1ULE1BQU0sQ0FBQ1UsS0FBUCxFQUFOO29CQUFBLENBQWpDO2tCQUNEO2dCQUNGLENBWE0sQ0FEVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7OztFQU42QkMsMEI7QUFzQi9COzs7Ozs7O0FBS0EsU0FBZ0JDLG9CQUFoQixDQUFxQ3JCLElBQXJDLEVBQXlDO0VBQ3ZDLE9BQU8sSUFBSUQsZ0JBQUosQ0FBcUJDLElBQXJCLENBQVA7QUFDRDs7QUFGRHNCIiwibmFtZXMiOlsiRmlsZVJlYWRlclNvdXJjZSIsImZpbGUiLCJzbGljZSIsInNpZ25hbCIsIlByb21pc2UiLCJyZXNvbHZlIiwicmVqZWN0IiwiYmxvYiIsIm9mZnNldCIsImxlbmd0aCIsInJlYWRlciIsIkZpbGVSZWFkZXIiLCJvbmxvYWQiLCJldmVudCIsInRhcmdldCIsInJlc3VsdCIsIm9uZXJyb3IiLCJvbmFib3J0IiwicmVhZEFzQXJyYXlCdWZmZXIiLCJhZGRFdmVudExpc3RlbmVyIiwiYWJvcnQiLCJiYXNlc291cmNlX2pzXzEiLCJtYWtlRmlsZVJlYWRlclNvdXJjZSIsImV4cG9ydHMiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vZGlzdC1tb2R1bGUvc291cmNlL2ZpbGVyZWFkZXIuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=